import { quiz } from '@constants/data'
import type { PriceData } from '@types'
import { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react'

type PriceDataType = Partial<PriceData> | null

export const PriceContext = createContext<PriceDataType>(null)
export const PriceContextSetter = createContext<Dispatch<SetStateAction<PriceDataType>>>(() => null)

export function PriceProvider({ children }: { children: ReactNode }) {
  const [priceData, setPriceData] = useState<PriceDataType>(quiz?.data?.totals || null)

  return (
    <PriceContext value={priceData}>
      <PriceContextSetter value={setPriceData}>
        {children}
      </PriceContextSetter>
    </PriceContext>
  )
}
